import React from "react";

const AiTools = ({ list = [] }) => {
  return (
    <section
      id="my_ai_list"
      className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8"
    >
      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            Known AIs
          </p>
          <h2 className="font-display text-3xl font-bold text-skin-text md:text-4xl">
            AI systems I actively use for coding, research, and execution
          </h2>
        </div>
        <p className="max-w-2xl text-sm leading-7 text-skin-muted">
          Added as a dedicated portfolio feature with individual logos and usage
          notes, all controlled from `biodata.json`.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
        {list.map((tool) => (
          <article
            key={tool.name}
            className="rounded-[1.75rem] border border-white/15 bg-black/10 p-5 shadow-glass transition hover:-translate-y-1"
          >
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/90 p-3">
              <img src={tool.logo} alt={tool.name} className="h-full w-full object-contain" />
            </div>
            <h3 className="mt-5 font-display text-2xl font-semibold text-skin-text">
              {tool.name}
            </h3>
            <p className="mt-2 text-sm font-medium text-skin-accentSoft">
              {tool.focus}
            </p>
            <p className="mt-3 text-sm leading-7 text-skin-muted">
              {tool.description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default AiTools;
